export default "__VITE_ASSET__1791db1a__"